export const phoneRegexp: RegExp = new RegExp(/^\d{9}$/);
